import React, { useState } from 'react';
import GConf from '../AssetsM/generalConf';
import axios from 'axios';
import { Button, Input , Dropdown} from 'semantic-ui-react';
function AddProffCard() {

    let [proffData, setProffData] = useState([]);


    const SaveProffFunction = () => {
        if (!proffData.p_nom) {alert('nom')} 
        else if (!proffData.p_email) {alert('email ')}
        else if (!proffData.p_matiere) {alert('matiere')}
        else {
            axios.post(`${GConf.ApiLink}/Admin/add-prof`, {
                proffData : proffData
            })
            .then(function (response) {
                
                 alert('Saved')
            })
        }
    }

    return ( <>
            <h5 className='text-secondary mb-1'> <span className='bi bi-person'></span> Nom du Proff : </h5>
            <Input  icon='user' iconPosition='left' placeholder='Nom .. ' className='shadow-sm w-100' onChange={(e) => setProffData({...proffData, p_nom: e.target.value })}/>

            <h5 className='text-secondary mb-1'> <span className='bi bi-person'></span> E-mail du Proff : </h5>
            <Input  icon='mail' iconPosition='left' placeholder='Email .. ' className='shadow-sm w-100' onChange={(e) => setProffData({...proffData, p_email: e.target.value })}/>

            <h5 className='text-secondary mb-1'> <span className='bi bi-person'></span> Matiere : </h5>
            {/* <Input  icon='user' iconPosition='left' placeholder='Nom .. ' className='shadow-sm w-100' onChange={(e) => setProffData({...proffData, p_matiere: e.target.value })}/> */}
            <Dropdown
                search
                selection
                wrapSelection={false}
                options={GConf.matiereListe.map((data, index) => ({id : index, value: data.nom, text:data.nom }))}
                placeholder='Selectionnez Matiere'
                className='mb-1 shadow-sm w-100'
                onChange={(e, { value }) => setProffData({...proffData, p_matiere: value })}
                value={proffData.p_matiere}
            />

            <div className='mb-3 mt-3'>
                <Button onClick={() => SaveProffFunction()}  style={{backgroundColor: '#0c4f8d', color:'white'}} className='shadow-sm w-100'> Enregistrer ce proff </Button>
            </div>
    </> );
}

export default AddProffCard;